import React from "react";

// Layered ambient background: technical grid + hex pattern + faint cyan/emerald orbs
export const TechBackground = ({ variant = "default" }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div className="absolute inset-0 tech-grid opacity-60" />
      <div className="absolute inset-0 hex-pattern opacity-70" />
      {variant === "hero" && (
        <>
          <div
            className="ambient-orb"
            style={{ width: 620, height: 620, background: "rgba(0,212,255,0.16)", top: "-180px", left: "-120px" }}
          />
          <div
            className="ambient-orb"
            style={{ width: 520, height: 520, background: "rgba(0,230,118,0.12)", bottom: "-160px", right: "-100px" }}
          />
        </>
      )}
      {variant === "default" && (
        <div
          className="ambient-orb"
          style={{ width: 480, height: 480, background: "rgba(0,212,255,0.07)", top: "10%", right: "-140px" }}
        />
      )}
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(120% 80% at 50% 0%, transparent 40%, #080A0C 100%)" }}
      />
    </div>
  );
};
